export default __webpack_public_path__ + "static/media/mint-slider.724d490e.png";